import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import {marketRegister} from "../../services/marketRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import Moment from 'react-moment';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class UserSettlements extends Component {

    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            isLoading: true,
            search: ""
        };
    };

    componentDidMount() {
        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/user/settlements');
            ReactGA4.send({ hitType: "pageview", page: "/user/settlements" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
        let reseller = null;
        console.log(this.props.match.params);
        if(this.props.match.params && this.props.match.params.reseller){
            reseller = this.props.match.params.reseller;
        }
        this._updateItems(reseller);
    }

    _updateItems(reseller){
        dataRegister.getSettlements(marketRegister.code(), reseller).then((response) => {
            if(response.constructor === Array){
                this.setState({campaigns: response, isLoading: false, error: false});
            }else{
                this.setState({isLoading: false});
            }
        }, (error) => {
            if(error.status === 401){
                userRegister.remove();
                tokenRegister.remove();
                //salesChannelRegister.removeAll();
                this.props.history.push("/login");
            }else{
                this.setState({isLoading: false, error: true});
            }
        });
    }

    _signOut() {
        userRegister.remove();
        tokenRegister.remove();
        //salesChannelRegister.removeAll();
        this.props.history.push("/login");
    }

    _selectSettlement(url){
        window.open(url, '_blank');
    }

    _approve(item){
        this.setState({isLoading: true});
        dataRegister.approve(marketRegister.code(), item.id).then((response) => {
            this._updateItems();
        }, (error) => {
            if(error.status === 401){
                userRegister.remove();
                tokenRegister.remove();
                this.props.history.push("/login");
            }else{
                this.setState({isLoading: false, error: true});
            }
        });
    }

    _filter(){
        let array = this.state.campaigns.filter((item) => {
            return item.end_date.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || item.approved_status.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 || JSON.stringify(item.id).indexOf(this.state.search.toLowerCase()) !== -1;
        });
        return array;
    }

    _renderText(item) {
        return langRegister.get("user-settlements", item);
    }

    render() {
        return (
            <div>
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>
                        <input value={this.state.search} onChange={(event) => this.setState({search: event.target.value})} placeholder={this._renderText("item_3")} className={Styles.contentHeaderSearchInput}/>
                        <img className={Styles.contentHeaderSearchInputIcon} src={require("../../assets/images/search_icon.png")}/>
                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    <div className={Styles.containerInner}>
                        {
                            !this.state.isLoading && this.state.campaigns.length > 0 && !this.state.error &&
                            this._filter().sort(function(a,b){
                                return new Date(b.end_date.replace(/\./g, "/")) - new Date(a.end_date.replace(/\./g, "/"));
                            }).map((item) => {
                                item.approved_status = item.approved_status.toLowerCase();
                                return(
                                    <div className={Styles.contentInnerItem}>
                                        <div className={Styles.contentInnerItemHeader}>
                                            <div className={Styles.contentInnerItemHeaderTitle}>
                                                {item.end_date}
                                            </div>
                                            {
                                                item.approved_status === "pending" &&
                                                <div className={Styles.contentInnerItemHeaderIndustry}>
                                                    {this._renderText("item_9")}&nbsp;
                                                </div>
                                            }
                                            {
                                                item.approved_status === "approved" &&
                                                <div className={Styles.contentInnerItemHeaderIndustry}>
                                                    {this._renderText("item_10")}&nbsp;
                                                </div>
                                            }
                                            <div className={Styles.contentInnerItemHeaderId}>#{item.id}</div>
                                            {
                                                !item.approved_at &&
                                                <div onClick={() => this._approve(item)} className={Styles.contentInnerItemHeaderApprove}>
                                                    {this._renderText("item_4")}
                                                </div>
                                            }
                                            {
                                                !item.approved_at &&
                                                <img onClick={() => this._approve(item)} src={require("../../assets/images/checkmark_active.svg")} className={Styles.contentInnerItemHeaderApproveMobile}/>
                                            }
                                            <div onClick={() => this._selectSettlement(item.url)} className={Styles.contentInnerItemHeaderEdit}>
                                                {this._renderText("item_2")}
                                            </div>
                                            <div onClick={() => this._selectSettlement(item.url)} className={Styles.contentInnerItemHeaderEditMobile}>
                                                <img className={Styles.contentInnerItemHeaderEditMobileIcon} src={require("../../assets/images/download_icon.png")}/>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        !this.state.isLoading && this.state.campaigns.length < 1 && !this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_7")}
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.noResult}>
                            {this._renderText("item_8")}
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default UserSettlements;


// WEBPACK FOOTER //
// ./src/components/user-settlements/component.js